var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('keep-alive',[_c(!_vm.isSelecting ? 'select-shipment' : 'select-bill-items',{tag:"component",attrs:{"shipmentIds":_vm.selectedShipmentIds},on:{"selectShipment":_vm.selectItems,"revert":function($event){return _vm.revert()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }